<template>
    <div class="zemlya-container">
        <div class="zemlya-mini-container">
            <zemlya-banners :banner-info="bannerInfo"></zemlya-banners>
            <zemlya-calendar :calendar-info="calendarInfo"></zemlya-calendar>
        </div>
        <zemlya-tags :tags-info="tagsInfo"></zemlya-tags>
        <zemlya-cards :cards-info="cardsInfo"></zemlya-cards>
    </div>
    
</template>

<script>
import { defineProps } from "vue";
import ZemlyaBanners from './ZemlyaBanners';
import ZemlyaCalendar from './ZemlyaCalendar';
import ZemlyaCards from './ZemlyaCards';
import ZemlyaTags from './ZemlyaTags';

export default {
	name: 'ZemlyaMainPage',
    components: { ZemlyaBanners },
	props: ['data-info'],
}
</script>

<script setup>
const props = defineProps(['data-info']);
const dataInfo = JSON.parse(props.dataInfo)

const bannerInfo = dataInfo.sections.banners;
const tagsInfo = dataInfo.sections.indicators.sections.items.sections;
const cardsInfo = dataInfo.sections.promo.sections.items.sections;
const calendarInfo = dataInfo.calendar;
</script>